// extracted by mini-css-extract-plugin
module.exports = {"container":"how-to-watch_container__dvQzX","blocks":"how-to-watch_blocks__hU6_4"};